import { BaseService } from "./baseService";
import { DocumentTypeDto, DocumentTypeFormData } from "../types/documentType";

class DocumentTypeService extends BaseService<DocumentTypeDto, DocumentTypeFormData> {
  constructor() {
    super("/DocumentType");
  }
}

export const documentTypeService = new DocumentTypeService();
